import { colors } from "../../../styles/colors"
import { fonts } from "../../../styles/fonts"

const outerWrapper = {
    display: "grid",
    gridTemplateAreas: "'area1 area2 area3 area4 area5 area6 area7 area8 area9 area10 area11 area12'",
    gridTemplateColumns: "repeat(12, 1fr)",
    background: "#fafbfc"
}

const topBar = {
    gridColumnStart: "area2",
    gridColumnEnd: "area11",
    display: "flex",
    justifyContent: "space-between",
    margin: "20px 0"
}

const plansList = {
    gridColumnStart: "area2",
    gridColumnEnd: "area11",
    marginTop: 20
}

const actionButton = {
    padding: "10px 40px"
}

const tableWrapper = {
    width: "100%",
    background: colors.white,
}

const tableHeader = {
    color: colors.slateBlue,
    fontFamily: fonts.boldFont,
    fontSize: 16,
    background: colors.white,
    borderRadius: 0,
    boxShadow: "0px 2px 8px 0px rgb(161,202,248,0.19)",
}

const tableData = {
    color: "#333333",
    "&:hover": {
        background: "#f3e0e9"
    },
    background: "#F2F4F8",
}

const firstCol = {
    width: "35%",
    padding: "15px 15px"
}

const secondCol = {
    width: "25%",
    padding: "15px 15px"
}

const thirdCol = {
    width: "20%",
    padding: "15px 15px"
}

const fourthCol = {
    padding: "15px 15px",
}

const dataRow = {
    borderTop: "15px solid #fafbfc",
    cursor: "pointer"
}

const subColumn: any = {
    paddingRight: "33px",
    cursor: "pointer",
    textTransform: "uppercase",
    color: colors.fuschiaPink,
    fontFamily: fonts.boldFont
}

const notFound: any = {
    textAlign: "center",
    fontSize: 16
}


export {
    outerWrapper,
    topBar,
    tableWrapper,
    actionButton,
    plansList,
    tableData,
    tableHeader,
    firstCol,
    secondCol,
    thirdCol,
    fourthCol,
    dataRow,
    subColumn,
    notFound
}